import React from 'react';
import PropTypes from 'prop-types';
import styles from './ErrorMessage.css';
import { setCardID } from '../../utils/Format/Format';

const ErrorMessageNewFund = (props) => {
    const { cardName } = props;
    return (
        <div
            id={setCardID(cardName, true)}
            className="no-data"
            data-testid="new-fund-error-message"
        >
            This fund is new, so its {cardName} information isn’t available yet.
            When it becomes available, it will display automatically.
            <style jsx>{styles}</style>
        </div>
    );
};

ErrorMessageNewFund.propTypes = {
    /**
     * card name to display in the message
     */
    cardName: PropTypes.string
};

ErrorMessageNewFund.defaultProps = {
    cardName: ''
};

export default ErrorMessageNewFund;
